<template>
  <div class="snackbar-stack">
    <TransitionGroup name="snackbar">
      <div v-for="notification in snackbarStore.notifications" :key="notification.id">
        <EgovInlineNotification
          :type="notification.type"
          :description="notification.description"
          title=""
          @close="snackbarStore.remove(notification.id)"
        />
      </div>
    </TransitionGroup>
  </div>
</template>

<script setup>
import { useSnackbarStore } from '@/stores/snackbar'
import EgovInlineNotification from './EgovInlineNotification.vue'

const snackbarStore = useSnackbarStore()
</script>

<style lang="scss" scoped>
.snackbar-stack {
  position: fixed;
  bottom: 50px;
  left: 50%;
  transform: translateX(-50%);
  width: 68vw;
  max-width: 75rem;
  z-index: 2500;
  display: flex;
  flex-direction: column;
  gap: 8px;

  > div {
    width: 100%;
  }
}

.snackbar-enter-active,
.snackbar-leave-active {
  transition: all 0.2s ease;
}

.snackbar-enter-from,
.snackbar-leave-to {
  opacity: 0;
  transform: translateY(8px);
}
</style>
